import {Component, OnInit, OnDestroy} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Response} from '@angular/http';
import {EventManager, AlertService, JhiLanguageService} from 'ng-jhipster';
import { MakerCheckerTransaction } from '../shared/model/maker-checker-master-action.model';
import { LoanOdAccountsService } from './loan-od-accounts.service';

@Component({
    selector: 'jhi-loan-od-accounts-maker-checker-transactions-approve',
    templateUrl: './loan-od-accounts-maker-checker-transactions-approve.component.html',
})
export class LoanOdAccountsTransactionsMakerCheckerApproveComponent implements OnInit {

    makerCheckerTransaction: MakerCheckerTransaction;
    private subscription: any;

    constructor(private jhiLanguageService: JhiLanguageService,
                private alertService: AlertService,
                private router: Router,
                private loanOdAccountsService: LoanOdAccountsService,
                private eventManager: EventManager,
                private route: ActivatedRoute) {
        // this.jhiLanguageService.setLocations(['loanOdAccounts']);
    }

    ngOnInit() {
        this.subscription = this.route.params.subscribe((params) => {
            this.load(params['id']);
        });
    }

    load(id) {
        this.loanOdAccountsService.transactionsMakerCheckerApproveEntry(id).subscribe((makerCheckerTransaction) => {
            this.makerCheckerTransaction = makerCheckerTransaction;
        });
    }

    clear() {
        this.router.navigate(['/loans/loan-od-accounts']);
    }
    back() {
        this.router.navigate(['/loans/loan-od-accounts/makerCheckerTransactions']);
    }

    confirm() {
        this.loanOdAccountsService.transactionsMakerCheckerExecute(this.makerCheckerTransaction).subscribe(
            (res) => { this.onConfirmSuccess(res) },
            (res) => { this.onConfirmError(res) }
        );
    }

    private onConfirmSuccess(result) {
       this.alertService.success('encoreclientApp.loanOdAccounts.approveTransactionSuccess', { code: this.makerCheckerTransaction.accountId });
       this.router.navigate(['/loans/loan-od-accounts/makerCheckerTransactions']);
    }

    private onConfirmError(error) {
        try {
            const errorString = error.json().localizedMessage;
            if (errorString) {
                this.alertService.error('encoreclientApp.loanOdAccounts.serverError', { message: errorString });
            } else {
            this.onError(error);
            }
        } catch (exception) {
            try {
                const errorString = error.text();
                if (errorString) {
                    this.alertService.error('encoreclientApp.loanOdAccounts.serverError', { message: errorString });
                } else {
                    this.onError(error);
                }
            } catch (exception) {
                this.onError(error);
            }
        }
        this.router.navigate(['/loans/loan-od-accounts/makerCheckerTransactions']);
    }

    private onError(error) {
        this.alertService.error('encoreclientApp.loanOdAccounts.saveError');
        this.router.navigate(['/loans/loan-od-accounts/makerCheckerTransactions']);
    }
}
